import styled from '@emotion/styled'
import { Box, Button } from '@mui/material'
import React from 'react'
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Link } from 'react-router-dom';
const FooterBox = styled(Box)({
    maxWidth: '90vw',
    margin: 'auto',
    display: 'grid',
    gap: '3rem',
    paddingTop: '5rem'
})

const Footer = () => {
  return (
    <Box style={{paddingBottom: '0.5rem', background: 'black'}}>
    <FooterBox sx={{gridTemplateColumns:{xs: '1fr', sm: '1fr 1fr', md: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }}} >
        <Box style={{maxWidth: '30rem', height: '30rem'}}>
            <Link to='/'>
                <img src="https://cdn.shopify.com/s/files/1/0057/8938/4802/files/Boat-Logo_200x.png?v=1600753267" 
                alt="" style={{height: '3.2rem', width: '8rem', position: 'relative', left:'-rem'}} />
            </Link>
            <p style={{textAlign: 'left'}}>Sunscribe to email alerts. We promise not to spam your inbox</p>
            <Box style={{height: '3rem', maxWidth: '27.5rem',gap: '1.2rem', border: '1px solid gray', borderRadius:"0.5rem", display: 'flex'}}>
                <form action="" style={{maxWidth: '18rem'}}>
                    <input type="text" name="name"  placeholder='enter your email...'
                            style={{minWidth: '17rem', height: '2.2rem', 
                            borderRadius: '0.5rem', border: '1px solid gray', margin:'auto', 
                            marginTop: '0.25rem',marginLeft: '0.5rem', background: 'black'}} />
                </form>
                <Button style={{height: 'fit-content', background: 'red', 
                                color: 'white', fontWeight: 'bolder', 
                                marginTop: '0.35rem', maxWidth: '9rem'}}>Subsribe</Button>
            </Box>
            <Box style={{position: 'relative', paddingTop:"1rem", display: 'flex', gap: '1.2rem'}}>
                <li ><a href='https://www.facebook.com/boat.nirvana/' target='newTab' style={{color: 'white'}}  ><FacebookIcon /> </a></li >
                <li ><a href='https://www.instagram.com/boat.nirvana/' target='newTab' style={{color: 'white'}} ><InstagramIcon /></a> </li >
                <li ><a href='https://twitter.com/RockWithboAt' target='newTab' style={{color: 'white'}} ><TwitterIcon /></a> </li >
                <li ><a href='https://www.youtube.com/channel/UCY3JXaO_v8H3E6hTYUp5qWQ' target='newTab' style={{color: 'white'}} ><YouTubeIcon /></a> </li >
                <li ><a href='https://www.linkedin.com/company/boat-lifestyle/' target='newTab' style={{color: 'white'}} ><LinkedInIcon /></a> </li >
            </Box>
            <img src="https://cdn.shopify.com/s/files/1/0057/8938/4802/files/Fotter_payment_icn_2_900x_aff68517-98f4-4a82-9aee-2405cea66251_350x.png?v=1650262054" alt="payment"
                style={{position: 'relative', top:'10rem'}} />
        </Box>



        <Box>
            <h3 style={{textAlign: 'left', paddingLeft: '2.5rem'}}>SHOP</h3>
            <ul style={{textAlign: 'left', listStyleType: 'none', fontSize: '0.8rem', color: 'white'}}>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >True Wireless Earbuds</li>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >Wireless Headphones</li>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >Wired Headphones</li>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >Wireless Speakers</li>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >Home Audio</li>
            </ul>
        </Box>
        <Box>
            <h3 style={{textAlign: 'left', paddingLeft: '2.5rem'}}>HELP</h3>
            <ul style={{textAlign: 'left', listStyleType: 'none', fontSize: '0.8rem', color: 'white'}}>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >Track Your Order</li>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >Warranty & Support</li>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >Return Policy</li>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >Return Policy</li>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >Bulk Orders</li>
            </ul>
        </Box>
        <Box>
            <h3 style={{textAlign: 'left', paddingLeft: '2.5rem'}}>COMPANY</h3>
            <ul style={{textAlign: 'left', listStyleType: 'none', fontSize: '0.8rem', color: 'white'}}>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >About boAt</li>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >News</li>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >Read Our Blog</li>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >Careers</li>
                <li style={{lineHeight: '1.3rem', cursor:'pointer'}}  >Security</li>
            </ul>
        </Box>
    </FooterBox>
    <h5 style={{texAlign: 'center', paddingTop: '5rem', color: 'gray'}}>© 2022 Imagine Marketing Limited. All Rights Reserved.</h5>
    </Box>
  )
}

export default Footer